<template>
    <div class="report-score-framingham"
         v-if="$store.state.patientParticipant.latestScoreDefs">

        <div class="framingham-value">
            {{ risk }}
        </div>

        <div class="mt-2" v-if="!risk">
            <em v-html="$i18n.gt('MESSAGE_REPORT_FRAMINGHAM_LIMITS')">
            </em>
        </div>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'
    import * as _ from 'lodash'

    /**
     * Displays the Framingham score
     */
    export default Vue.extend({
        computed: {
            scoreDef() {
                return this.$store.state.patientParticipant.latestScoreDefs['FRAMINGHAM_SCORE']
            },
            risk() {
                if (!this.scoreDef) {
                    return null
                } else {
                    const fs = this.scoreDef.score.score
                    if (fs === null) {
                        return this.$i18n.gt('HEADING_REPORT_CVD_LIKELIHOOD_NA')
                    } else if (fs < .01) {
                        // 'Less than {percent}'
                        return this.$i18n.gt('HEADING_REPORT_CVD_LIKELIHOOD_LESS_THAN').replace('{percent}', '1%')
                    } else if (fs > .3) {
                        // 'Greater than {percent}'
                        return this.$i18n.gt('HEADING_REPORT_CVD_LIKELIHOOD_MORE_THAN').replace('{percent}', '30%')
                    } else {
                        return Number(100 * fs).toFixed(0) + '%'
                    }
                }
            }
        }
    })
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
    .report-score-framingham {
        .framingham-value {
            font-weight: bold;
            min-width: 100px;
            padding: .25rem .5rem;
            margin: .5em auto;
            border-radius: 4px;
            background: #f0f0f0;
            text-align: center;
            font-size: 16px;
        }
    }
</style>

